import { useState } from "react";
import { useAuth } from "../../lib/auth";
import { SignupWizard } from "./SignupWizard";
import { ForgotPasswordPage } from "./ForgotPasswordPage";
import { AuthFrame, AuthHead, IconField } from "./AuthFrame";

export function LoginScreen() {
  const { login, loading, error } = useAuth();
  const [mode, setMode] = useState<"login" | "signup" | "forgot">("login");
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");

  if (mode === "signup") return <SignupWizard onSwitchToLogin={() => setMode("login")} />;

  return (
    <AuthFrame>
      {mode === "forgot" ? (
        <ForgotPasswordPage onBackToLogin={() => setMode("login")} />
      ) : (
        <form
          className="o-auth__form"
          onSubmit={(e) => {
            e.preventDefault();
            void login(email, pw);
          }}
        >
          <AuthHead title="Welcome back" sub="Sign in to your CliqSuite workspace." />
          <IconField label="Email" icon="mail" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@business.com" required />
          <IconField label="Password" icon="lock" type="password" autoComplete="current-password" value={pw} onChange={(e) => setPw(e.target.value)} required />
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: -6 }}>
            <button type="button" className="o-link" style={{ fontSize: 13.5 }} onClick={() => setMode("forgot")}>
              Forgot password?
            </button>
          </div>
          {error && <div className="o-error" style={{ marginTop: 0 }}>{error}</div>}
          <button type="submit" className="o-auth__submit" disabled={loading}>
            {loading ? "Signing in…" : "Sign in"}
            {!loading && <span className="ms" aria-hidden="true">arrow_forward</span>}
          </button>
          <button type="button" className="o-link o-auth__alt" onClick={() => setMode("signup")}>
            New to CliqSuite? Create your business
          </button>
        </form>
      )}
    </AuthFrame>
  );
}
